import BigNumber from 'bignumber.js'
import { Rarity } from 'config/constants/types'

// Lock Data
export interface LockData {
  lid: number
  amount: BigNumber
  lockAt: number
  duration: number
  lastRewardAt: number
  unlocked: boolean
  nfts: number[]
}

export interface LockV2Data {
  id: number
  owner: string
  tokenAmount: BigNumber
  lockAt: number
  duration: number
  lastRewardAt: number
  listPrice: BigNumber
  listed: boolean
  nftIds: number[]
  nftRarities: Rarity[]
}

export interface LockV2Config {
  aprRates: any
  boostRates: any
  minToken: BigNumber
  maxNft: number
  penaltyStart: number
  penaltyDelta: number
}

export type LockStatus = 'locked' | 'finished'

export enum LockDuration {
  '3 months' = 90 * 3600 * 24,
  '6 months' = 180 * 3600 * 24,
  '1 year' = 365 * 3600 * 24,
  '2 years' = 730 * 3600 * 24,
}